// extracted by mini-css-extract-plugin
export default {"product":"tV","image_carousel":"uV","main_gallery":"vV","personalized_badge":"wV","greens_badge":"xV","arrows":"yV","slide":"zV","thumbnail_gallery":"AV","swiper-slide":"BV","learn_more":"CV","product_info":"EV","description_wrapper":"FV","checklist":"GV","checklistItem":"HV","delivery_freq":"IV","tooltip_button":"JV","key_benefits":"KV","benefit_item":"LV","ingredients":"MV","ingredient_item":"NV","active_slide":"OV","benefits_list":"PV","checkmark":"QV"};
    if(module.hot) {
      // 1713809679285
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  